import { FRONTEND_SYSTEM_STAFF_PRIORITY_COMPANY_UUID } from '@/constant/client/company'

export interface CompanyListItem {
  companyUuid: string
}

interface SortCompanyListForDisplayOptions {
  selectedCompanyUuid?: string
  isSystemStaff?: boolean
  priorityCompanyUuid?: string
}

const moveCompanyToIndex = <T extends CompanyListItem>(list: T[], companyUuid: string, targetIndex: number) => {
  const currentIndex = list.findIndex((company) => company.companyUuid === companyUuid)
  if (currentIndex === -1 || currentIndex === targetIndex) {
    return
  }

  const [company] = list.splice(currentIndex, 1)
  list.splice(targetIndex, 0, company)
}

const getSelectedFirstCompanyList = <T extends CompanyListItem>(list: T[], selectedCompanyUuid?: string) => {
  const orderedList = [...list]

  if (selectedCompanyUuid) {
    moveCompanyToIndex(orderedList, selectedCompanyUuid, 0)
  }

  return orderedList
}

/**
 * 依前台公司選擇器規則排序公司列表
 * - 若使用者為 system staff，且公司列表中有 priorityCompanyUuid，則將該公司置頂
 * - 其他情況則將 selectedCompanyUuid 的公司置頂（若有）
 */
export const sortCompanyListForDisplay = <T extends CompanyListItem>(
  list: T[],
  {
    selectedCompanyUuid,
    isSystemStaff = false,
    priorityCompanyUuid = FRONTEND_SYSTEM_STAFF_PRIORITY_COMPANY_UUID
  }: SortCompanyListForDisplayOptions
) => {
  if (!isSystemStaff) {
    return getSelectedFirstCompanyList(list, selectedCompanyUuid)
  }

  const hasPriorityCompany = list.some((company) => company.companyUuid === priorityCompanyUuid)
  if (!hasPriorityCompany) {
    return getSelectedFirstCompanyList(list, selectedCompanyUuid)
  }

  const orderedList = [...list]
  moveCompanyToIndex(orderedList, priorityCompanyUuid, 0)

  if (selectedCompanyUuid && selectedCompanyUuid !== priorityCompanyUuid) {
    moveCompanyToIndex(orderedList, selectedCompanyUuid, 1)
  }

  return orderedList
}
